'use strict';

const Mn = require('backbone.marionette');
const DiagramActionCreator = require('system/domain/action/diagram');
const Template = require('system/ui/template/diagram/directory.hbs');

module.exports = Mn.CompositeView.extend({
    childViewContainer: '.diagram-list',
    tagName: 'li',
    className: 'list-item diagram-directory',
    template: Template,
    events: {
        'click > .list-item-icon': 'toggle',
        'click > .list-item-content': 'toggle'
    },
    modelEvents: {
        'change:open': 'changeOpen'
    },
    ui: {
        openStateIcon: '.list-item-icon i'
    },
    childViewOptions: function () {
        return {
            context: this._context,
            isMember: this._isMember,
            collection: this.collection,
            childView: this.childView,
            editMode: this.getOption('editMode'),
            diagram: this.getOption('diagram'),
            showDescription: this.getOption('showDescription')
        };
    },

    initialize: function (options) {
        this._context = options.context;
        this._isMember = options.isMember;
        this.childView = options.childView;
        this.viewComparator = options.viewComparator;
        this._fetched = false;
    },

    filter: function (child) {
        if (child.isDeleted()) {
            return false;
        }
        if (child.get('directory')) {
            // id が undefined の場合は常に false にする
            return this.model.id &&
                child.get('parentDirectory') == this.model.id;
        }
        return _.contains(this.model.get('diagrams'), child.id);
    },

    serializeData: function () {
        var j = this.model.toJSON();

        j.isMember = this._isMember;
        // 配下のダイアグラムの fetch が完了していない場合でも正しい数字を
        // 表示するための `diagrams` プロパティを利用する
        j.childDiagramNum = _.uniq(
            // 配下のダイアグラム
            this.collection.chain()
                .filter(function (m) {
                    return !m.get('directory');
                })
                .filter(this.filter, this)
                .map(m => m.id)
                .value() +
            // 自分の子ダイアグラムのリスト
            this._fetched ? this.model.get('diagrams') : []).length;

        j.childDirectoryNum = this.collection.chain()
            .filter(function (m) {
                return m.get('directory');
            })
            .filter(this.filter, this)
            .size()
            .value();

        return j;
    },

    onRender: function () {
        this.changeOpen();
    },

    onDomRefresh: function () {
        $('[data-toggle="tooltip"]').tooltip();
    },

    changeOpen: function () {
        if (this.model.get('open')) {
            this.$el.css('height', 'auto');
            this.ui.openStateIcon.removeClass('fa-folder');
            this.ui.openStateIcon.addClass('fa-folder-open');
            this.$el.css('overflow', 'none');
        } else {
            this.$el.css('height', '48px');
            this.ui.openStateIcon.addClass('fa-folder');
            this.ui.openStateIcon.removeClass('fa-folder-open');
            this.$el.css('overflow', 'hidden');
        }
    },

    toggle: function (e) {
        e.stopPropagation();
        if (this.model.get('open')) {
            this.close();
        } else {
            this.open();
        }
    },

    open: function () {
        DiagramActionCreator.fetchDiagramsInDirectoryOnce(
            this._context.projectId,
            this.model.id
        ).then(() => {
            this._fetched = true;
            this.model.set({open: true});
        });
    },

    close: function () {
        this.model.set({open: false});
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/diagram/directory.js